import { z } from 'zod';

import { mobilePhoneIssue } from '@/utils/phoneNumber';

export const mobilePhoneSchema = z
  .object({
    country: z.string(),
    number: z.string(),
  })
  .superRefine((value, ctx) => {
    const issue = mobilePhoneIssue(value);
    if (issue) ctx.addIssue({ code: z.ZodIssueCode.custom, message: issue });
  });

export type MobilePhoneSchema = z.infer<typeof mobilePhoneSchema>;
